const e = "cheerfyFont_TbgH3", n = "chevron_ZwYp4", t = "chevront_8kN7q", o = "chevronw_k95G-", c = "eyet_G54Qc", r = "moret_-Gj9B", a = "menut_16We8", s = "menu_eDkcc", i = "calendar_IcV0X", _ = "information_bfObl", h = "line_AJ0E5", m = "delivery_zhQUm", v = "dinein_vcusU", y = "takeaway_X8TTQ", l = {
  cheerfyFont: e,
  chevron: n,
  chevront: t,
  chevronw: o,
  eyet: c,
  moret: r,
  menut: a,
  menu: s,
  calendar: i,
  information: _,
  line: h,
  delivery: m,
  dinein: v,
  takeaway: y
};
export {
  i as calendar,
  e as cheerfyFont,
  n as chevron,
  t as chevront,
  o as chevronw,
  l as default,
  m as delivery,
  v as dinein,
  c as eyet,
  _ as information,
  h as line,
  s as menu,
  a as menut,
  r as moret,
  y as takeaway
};
//# sourceMappingURL=cheerfyFont.module.scss.js.map
